export default {
  SET_EMAIL_LIST(state, payload) {
    state.emailList = payload
  },
  SET_LEVEL_LIST(state, payload) {
    state.levelList = payload
  },
  SET_ID_LIST(state, payload) {
    state.idList = payload
  },
  UPDATE_USER_LIST(state, payload) {
    state.setUserList = payload
  }
}
